webpackJsonp([114276838955818,60335399758886],{

/***/ 306:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(697);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(306);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	!function(root, factory) {
	     true ? module.exports = factory(__webpack_require__(4)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.react);
	}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_8__) {
	    return function(modules) {
	        function __webpack_require__(moduleId) {
	            if (installedModules[moduleId]) return installedModules[moduleId].exports;
	            var module = installedModules[moduleId] = {
	                i: moduleId,
	                l: !1,
	                exports: {}
	            };
	            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
	            module.l = !0, module.exports;
	        }
	        var installedModules = {};
	        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
	        __webpack_require__.d = function(exports, name, getter) {
	            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
	                configurable: !1,
	                enumerable: !0,
	                get: getter
	            });
	        }, __webpack_require__.n = function(module) {
	            var getter = module && module.__esModule ? function() {
	                return module.default;
	            } : function() {
	                return module;
	            };
	            return __webpack_require__.d(getter, "a", getter), getter;
	        }, __webpack_require__.o = function(object, property) {
	            return Object.prototype.hasOwnProperty.call(object, property);
	        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 7);
	    }([ function(module, exports, __webpack_require__) {
	        var REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, isValidElement = function(object) {
	            return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
	        };
	        module.exports = __webpack_require__(9)(isValidElement, !0);
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function makeEmptyFunction(arg) {
	            return function() {
	                return arg;
	            };
	        }
	        var emptyFunction = function() {};
	        emptyFunction.thatReturns = makeEmptyFunction, emptyFunction.thatReturnsFalse = makeEmptyFunction(!1), 
	        emptyFunction.thatReturnsTrue = makeEmptyFunction(!0), emptyFunction.thatReturnsNull = makeEmptyFunction(null), 
	        emptyFunction.thatReturnsThis = function() {
	            return this;
	        }, emptyFunction.thatReturnsArgument = function(arg) {
	            return arg;
	        }, module.exports = emptyFunction;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function invariant(condition, format, a, b, c, d, e, f) {
	            if (validateFormat(format), !condition) {
	                var error;
	                if (void 0 === format) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."); else {
	                    var args = [ a, b, c, d, e, f ], argIndex = 0;
	                    error = new Error(format.replace(/%s/g, function() {
	                        return args[argIndex++];
	                    })), error.name = "Invariant Violation";
	                }
	                throw error.framesToPop = 1, error;
	            }
	        }
	        var validateFormat = function(format) {};
	        validateFormat = function(format) {
	            if (void 0 === format) throw new Error("invariant requires an error message argument");
	        }, module.exports = invariant;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        var emptyFunction = __webpack_require__(1), warning = emptyFunction, printWarning = function(format) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
	            var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
	                return args[argIndex++];
	            });
	            "undefined" != typeof console && console.error(message);
	            try {
	                throw new Error(message);
	            } catch (x) {}
	        };
	        warning = function(condition, format) {
	            if (void 0 === format) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
	            if (0 !== format.indexOf("Failed Composite propType: ") && !condition) {
	                for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
	                printWarning.apply(void 0, [ format ].concat(args));
	            }
	        }, module.exports = warning;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function hyphenateStyleName(string) {
	            return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
	        }
	        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
	        module.exports = hyphenateStyleName;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        });
	        var _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _propTypes = __webpack_require__(0), _propTypes2 = function(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }(_propTypes), stringOrNumber = _propTypes2.default.oneOfType([ _propTypes2.default.string, _propTypes2.default.number ]), matchers = {
	            orientation: _propTypes2.default.oneOf([ "portrait", "landscape" ]),
	            scan: _propTypes2.default.oneOf([ "progressive", "interlace" ]),
	            aspectRatio: _propTypes2.default.string,
	            deviceAspectRatio: _propTypes2.default.string,
	            height: stringOrNumber,
	            deviceHeight: stringOrNumber,
	            width: stringOrNumber,
	            deviceWidth: stringOrNumber,
	            color: _propTypes2.default.bool,
	            colorIndex: _propTypes2.default.bool,
	            monochrome: _propTypes2.default.bool,
	            resolution: stringOrNumber
	        }, features = _extends({
	            minAspectRatio: _propTypes2.default.string,
	            maxAspectRatio: _propTypes2.default.string,
	            minDeviceAspectRatio: _propTypes2.default.string,
	            maxDeviceAspectRatio: _propTypes2.default.string,
	            minHeight: stringOrNumber,
	            maxHeight: stringOrNumber,
	            minDeviceHeight: stringOrNumber,
	            maxDeviceHeight: stringOrNumber,
	            minWidth: stringOrNumber,
	            maxWidth: stringOrNumber,
	            minDeviceWidth: stringOrNumber,
	            maxDeviceWidth: stringOrNumber,
	            minColor: _propTypes2.default.number,
	            maxColor: _propTypes2.default.number,
	            minColorIndex: _propTypes2.default.number,
	            maxColorIndex: _propTypes2.default.number,
	            minMonochrome: _propTypes2.default.number,
	            maxMonochrome: _propTypes2.default.number,
	            minResolution: stringOrNumber,
	            maxResolution: stringOrNumber
	        }, matchers), types = {
	            all: _propTypes2.default.bool,
	            grid: _propTypes2.default.bool,
	            aural: _propTypes2.default.bool,
	            braille: _propTypes2.default.bool,
	            handheld: _propTypes2.default.bool,
	            print: _propTypes2.default.bool,
	            projection: _propTypes2.default.bool,
	            screen: _propTypes2.default.bool,
	            tty: _propTypes2.default.bool,
	            tv: _propTypes2.default.bool,
	            embossed: _propTypes2.default.bool
	        }, all = _extends({}, types, features);
	        matchers.type = Object.keys(types), exports.default = {
	            all: all,
	            types: types,
	            matchers: matchers,
	            features: features
	        }, module.exports = exports.default;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function _classCallCheck(instance, Constructor) {
	            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
	        }
	        function _possibleConstructorReturn(self, call) {
	            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	            return !call || "object" != typeof call && "function" != typeof call ? self : call;
	        }
	        function _inherits(subClass, superClass) {
	            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	            subClass.prototype = Object.create(superClass && superClass.prototype, {
	                constructor: {
	                    value: subClass,
	                    enumerable: !1,
	                    writable: !0,
	                    configurable: !0
	                }
	            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	        }
	        function omit(object, keys) {
	            var newObject = _extends({}, object);
	            return keys.forEach(function(key) {
	                return delete newObject[key];
	            }), newObject;
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.toQuery = exports.default = void 0;
	        var _createClass = function() {
	            function defineProperties(target, props) {
	                for (var i = 0; i < props.length; i++) {
	                    var descriptor = props[i];
	                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
	                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	                }
	            }
	            return function(Constructor, protoProps, staticProps) {
	                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
	                Constructor;
	            };
	        }(), _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _react = __webpack_require__(8), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(0), _propTypes2 = _interopRequireDefault(_propTypes), _matchmediaquery = __webpack_require__(12), _matchmediaquery2 = _interopRequireDefault(_matchmediaquery), _hyphenateStyleName = __webpack_require__(5), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(6), _mediaQuery2 = _interopRequireDefault(_mediaQuery), _toQuery = __webpack_require__(14), _toQuery2 = _interopRequireDefault(_toQuery), defaultTypes = {
	            component: _propTypes2.default.node,
	            query: _propTypes2.default.string,
	            values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
	            children: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.func ]),
	            onChange: _propTypes2.default.func,
	            onBeforeChange: _propTypes2.default.func
	        }, mediaKeys = Object.keys(_mediaQuery2.default.all), excludedQueryKeys = Object.keys(defaultTypes), excludedPropKeys = excludedQueryKeys.concat(mediaKeys), MediaQuery = function(_React$Component) {
	            function MediaQuery() {
	                var _ref, _temp, _this, _ret;
	                _classCallCheck(this, MediaQuery);
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
	                return _temp = _this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [ this ].concat(args))), 
	                _this.state = {
	                    matches: !1
	                }, _this.updateMatches = function() {
	                    _this._mql.matches !== _this.state.matches && _this.setState({
	                        matches: _this._mql.matches
	                    });
	                }, _this.removeMql = function() {
	                    _this._mql && (_this._mql.removeListener(_this.updateMatches), _this._mql.dispose());
	                }, _ret = _temp, _possibleConstructorReturn(_this, _ret);
	            }
	            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, [ {
	                key: "componentWillMount",
	                value: function() {
	                    this.updateQuery(this.props);
	                }
	            }, {
	                key: "componentWillReceiveProps",
	                value: function(nextProps) {
	                    this.updateQuery(nextProps);
	                }
	            }, {
	                key: "updateQuery",
	                value: function(props) {
	                    var values = void 0;
	                    if (props.query ? this.query = props.query : this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys)), 
	                    !this.query) throw new Error("Invalid or missing MediaQuery!");
	                    props.values && (values = Object.keys(props.values).reduce(function(result, key) {
	                        return result[(0, _hyphenateStyleName2.default)(key)] = props.values[key], result;
	                    }, {})), this.removeMql(), this._mql = (0, _matchmediaquery2.default)(this.query, values), 
	                    this._mql.addListener(this.updateMatches), this.updateMatches();
	                }
	            }, {
	                key: "componentWillUpdate",
	                value: function(_, nextState) {
	                    this.props.onBeforeChange && this.state.matches !== nextState.matches && this.props.onBeforeChange(this.state.matches);
	                }
	            }, {
	                key: "componentDidUpdate",
	                value: function(_, prevState) {
	                    this.props.onChange && prevState.matches !== this.state.matches && this.props.onChange(this.state.matches);
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function() {
	                    this.removeMql();
	                }
	            }, {
	                key: "render",
	                value: function() {
	                    if ("function" == typeof this.props.children) return this.props.children(this.state.matches);
	                    if (!1 === this.state.matches) return null;
	                    var props = omit(this.props, excludedPropKeys), hasMergeProps = Object.keys(props).length > 0, childrenCount = _react2.default.Children.count(this.props.children);
	                    return this.props.component || null == this.props.children || hasMergeProps && childrenCount > 1 ? _react2.default.createElement(this.props.component || "div", props, this.props.children) : hasMergeProps ? _react2.default.cloneElement(this.props.children, props) : childrenCount ? this.props.children : null;
	                }
	            } ]), MediaQuery;
	        }(_react2.default.Component);
	        MediaQuery.displayName = "MediaQuery", MediaQuery.defaultProps = {
	            values: {}
	        }, exports.default = MediaQuery, exports.toQuery = _toQuery2.default;
	    }, function(module, exports) {
	        module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        var emptyFunction = __webpack_require__(1), invariant = __webpack_require__(2), warning = __webpack_require__(3), assign = __webpack_require__(10), ReactPropTypesSecret = __webpack_require__(4), checkPropTypes = __webpack_require__(11);
	        module.exports = function(isValidElement, throwOnDirectAccess) {
	            function getIteratorFn(maybeIterable) {
	                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	                if ("function" == typeof iteratorFn) return iteratorFn;
	            }
	            function is(x, y) {
	                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
	            }
	            function PropTypeError(message) {
	                this.message = message, this.stack = "";
	            }
	            function createChainableTypeChecker(validate) {
	                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
	                    secret !== ReactPropTypesSecret) if (throwOnDirectAccess) invariant(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"); else if ("undefined" != typeof console) {
	                        var cacheKey = componentName + ":" + propName;
	                        !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (warning(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName), 
	                        manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
	                    }
	                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
	                }
	                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
	                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
	            }
	            function createPrimitiveTypeChecker(expectedType) {
	                function validate(props, propName, componentName, location, propFullName, secret) {
	                    var propValue = props[propName];
	                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createArrayOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
	                    var propValue = props[propName];
	                    if (!Array.isArray(propValue)) {
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
	                    }
	                    for (var i = 0; i < propValue.length; i++) {
	                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createInstanceTypeChecker(expectedClass) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if (!(props[propName] instanceof expectedClass)) {
	                        var expectedClassName = expectedClass.name || ANONYMOUS;
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createEnumTypeChecker(expectedValues) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` supplied to `" + componentName + "`, expected one of " + JSON.stringify(expectedValues) + ".");
	                }
	                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (warning(!1, "Invalid argument supplied to oneOf, expected an instance of array."), 
	                emptyFunction.thatReturnsNull);
	            }
	            function createObjectOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
	                    for (var key in propValue) if (propValue.hasOwnProperty(key)) {
	                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createUnionTypeChecker(arrayOfTypeCheckers) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
	                    }
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
	                }
	                if (!Array.isArray(arrayOfTypeCheckers)) return warning(!1, "Invalid argument supplied to oneOfType, expected an instance of array."), 
	                emptyFunction.thatReturnsNull;
	                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                    var checker = arrayOfTypeCheckers[i];
	                    if ("function" != typeof checker) return warning(!1, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i), 
	                    emptyFunction.thatReturnsNull;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    for (var key in shapeTypes) {
	                        var checker = shapeTypes[key];
	                        if (checker) {
	                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                            if (error) return error;
	                        }
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createStrictShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    var allKeys = assign({}, props[propName], shapeTypes);
	                    for (var key in allKeys) {
	                        var checker = shapeTypes[key];
	                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
	                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function isNode(propValue) {
	                switch (typeof propValue) {
	                  case "number":
	                  case "string":
	                  case "undefined":
	                    return !0;
	
	                  case "boolean":
	                    return !propValue;
	
	                  case "object":
	                    if (Array.isArray(propValue)) return propValue.every(isNode);
	                    if (null === propValue || isValidElement(propValue)) return !0;
	                    var iteratorFn = getIteratorFn(propValue);
	                    if (!iteratorFn) return !1;
	                    var step, iterator = iteratorFn.call(propValue);
	                    if (iteratorFn !== propValue.entries) {
	                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
	                    } else for (;!(step = iterator.next()).done; ) {
	                        var entry = step.value;
	                        if (entry && !isNode(entry[1])) return !1;
	                    }
	                    return !0;
	
	                  default:
	                    return !1;
	                }
	            }
	            function isSymbol(propType, propValue) {
	                return "symbol" === propType || ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
	            }
	            function getPropType(propValue) {
	                var propType = typeof propValue;
	                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
	            }
	            function getPreciseType(propValue) {
	                if (void 0 === propValue || null === propValue) return "" + propValue;
	                var propType = getPropType(propValue);
	                if ("object" === propType) {
	                    if (propValue instanceof Date) return "date";
	                    if (propValue instanceof RegExp) return "regexp";
	                }
	                return propType;
	            }
	            function getPostfixForTypeWarning(value) {
	                var type = getPreciseType(value);
	                switch (type) {
	                  case "array":
	                  case "object":
	                    return "an " + type;
	
	                  case "boolean":
	                  case "date":
	                  case "regexp":
	                    return "a " + type;
	
	                  default:
	                    return type;
	                }
	            }
	            function getClassName(propValue) {
	                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
	            }
	            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
	                array: createPrimitiveTypeChecker("array"),
	                bool: createPrimitiveTypeChecker("boolean"),
	                func: createPrimitiveTypeChecker("function"),
	                number: createPrimitiveTypeChecker("number"),
	                object: createPrimitiveTypeChecker("object"),
	                string: createPrimitiveTypeChecker("string"),
	                symbol: createPrimitiveTypeChecker("symbol"),
	                any: function() {
	                    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	                }(),
	                arrayOf: createArrayOfTypeChecker,
	                element: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        var propValue = props[propName];
	                        if (!isValidElement(propValue)) {
	                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
	                        }
	                        return null;
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                instanceOf: createInstanceTypeChecker,
	                node: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                objectOf: createObjectOfTypeChecker,
	                oneOf: createEnumTypeChecker,
	                oneOfType: createUnionTypeChecker,
	                shape: createShapeTypeChecker,
	                exact: createStrictShapeTypeChecker
	            };
	            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
	            ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function toObject(val) {
	            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
	            return Object(val);
	        }
	        /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
	        module.exports = function() {
	            try {
	                if (!Object.assign) return !1;
	                var test1 = new String("abc");
	                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
	                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
	                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
	                    return test2[n];
	                }).join("")) return !1;
	                var test3 = {};
	                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
	                    test3[letter] = letter;
	                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
	            } catch (err) {
	                return !1;
	            }
	        }() ? Object.assign : function(target, source) {
	            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
	                from = Object(arguments[s]);
	                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
	                if (getOwnPropertySymbols) {
	                    symbols = getOwnPropertySymbols(from);
	                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
	                }
	            }
	            return to;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	            for (var typeSpecName in typeSpecs) if (typeSpecs.hasOwnProperty(typeSpecName)) {
	                var error;
	                try {
	                    invariant("function" == typeof typeSpecs[typeSpecName], "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]), 
	                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	                } catch (ex) {
	                    error = ex;
	                }
	                if (warning(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error), 
	                error instanceof Error && !(error.message in loggedTypeFailures)) {
	                    loggedTypeFailures[error.message] = !0;
	                    var stack = getStack ? getStack() : "";
	                    warning(!1, "Failed %s type: %s%s", location, error.message, null != stack ? stack : "");
	                }
	            }
	        }
	        var invariant = __webpack_require__(2), warning = __webpack_require__(3), ReactPropTypesSecret = __webpack_require__(4), loggedTypeFailures = {};
	        module.exports = checkPropTypes;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function Mql(query, values) {
	            function addListener(listener) {
	                mql && mql.addListener(listener);
	            }
	            function removeListener(listener) {
	                mql && mql.removeListener(listener);
	            }
	            function update(evt) {
	                self.matches = evt.matches, self.media = evt.media;
	            }
	            function dispose() {
	                mql && mql.removeListener(update);
	            }
	            var self = this;
	            if (dynamicMatch) {
	                var mql = dynamicMatch.call(window, query);
	                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
	            } else this.matches = staticMatch(query, values), this.media = query;
	            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
	        }
	        function matchMedia(query, values) {
	            return new Mql(query, values);
	        }
	        var staticMatch = __webpack_require__(13).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
	        module.exports = matchMedia;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function matchQuery(mediaQuery, values) {
	            return parseQuery(mediaQuery).some(function(query) {
	                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
	                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
	                var expressionsMatch = query.expressions.every(function(expression) {
	                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
	                    if (!value) return !1;
	                    switch (feature) {
	                      case "orientation":
	                      case "scan":
	                        return value.toLowerCase() === expValue.toLowerCase();
	
	                      case "width":
	                      case "height":
	                      case "device-width":
	                      case "device-height":
	                        expValue = toPx(expValue), value = toPx(value);
	                        break;
	
	                      case "resolution":
	                        expValue = toDpi(expValue), value = toDpi(value);
	                        break;
	
	                      case "aspect-ratio":
	                      case "device-aspect-ratio":
	                      case "device-pixel-ratio":
	                        expValue = toDecimal(expValue), value = toDecimal(value);
	                        break;
	
	                      case "grid":
	                      case "color":
	                      case "color-index":
	                      case "monochrome":
	                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
	                    }
	                    switch (modifier) {
	                      case "min":
	                        return value >= expValue;
	
	                      case "max":
	                        return value <= expValue;
	
	                      default:
	                        return value === expValue;
	                    }
	                });
	                return expressionsMatch && !inverse || !expressionsMatch && inverse;
	            });
	        }
	        function parseQuery(mediaQuery) {
	            return mediaQuery.split(",").map(function(query) {
	                query = query.trim();
	                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
	                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
	                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
	                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	                    return {
	                        modifier: feature[1],
	                        feature: feature[2],
	                        value: captures[2]
	                    };
	                }), parsed;
	            });
	        }
	        function toDecimal(ratio) {
	            var numbers, decimal = Number(ratio);
	            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
	            decimal;
	        }
	        function toDpi(resolution) {
	            var value = parseFloat(resolution);
	            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
	              case "dpcm":
	                return value / 2.54;
	
	              case "dppx":
	                return 96 * value;
	
	              default:
	                return value;
	            }
	        }
	        function toPx(length) {
	            var value = parseFloat(length);
	            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
	              case "em":
	              case "rem":
	                return 16 * value;
	
	              case "cm":
	                return 96 * value / 2.54;
	
	              case "mm":
	                return 96 * value / 2.54 / 10;
	
	              case "in":
	                return 96 * value;
	
	              case "pt":
	                return 72 * value;
	
	              case "pc":
	                return 72 * value / 12;
	
	              default:
	                return value;
	            }
	        }
	        exports.match = matchQuery, exports.parse = parseQuery;
	        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function keyVal(k, v) {
	            var realKey = (0, _hyphenateStyleName2.default)(k);
	            return "number" == typeof v && (v += "px"), !0 === v ? k : !1 === v ? negate(k) : "(" + realKey + ": " + v + ")";
	        }
	        function join(conds) {
	            return conds.join(" and ");
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.default = function(obj) {
	            var rules = [];
	            return Object.keys(_mediaQuery2.default.all).forEach(function(k) {
	                var v = obj[k];
	                null != v && rules.push(keyVal(k, v));
	            }), join(rules);
	        };
	        var _hyphenateStyleName = __webpack_require__(5), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(6), _mediaQuery2 = _interopRequireDefault(_mediaQuery), negate = function(cond) {
	            return "not " + cond;
	        };
	        module.exports = exports.default;
	    } ]);
	});
	//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  z-index: 1000;\n  position: fixed;\n  top: 35%;\n  right: 1%;\n  display: flex;\n  flex-direction: column;\n  transform-origin: 0 100%;\n  transition: all 0.5s;\n\n  @media (min-width: 1200px) {\n    right: ', ';\n    width: ', ';\n    height: ', ';\n    transform: ', ';\n  }\n'], ['\n  z-index: 1000;\n  position: fixed;\n  top: 35%;\n  right: 1%;\n  display: flex;\n  flex-direction: column;\n  transform-origin: 0 100%;\n  transition: all 0.5s;\n\n  @media (min-width: 1200px) {\n    right: ', ';\n    width: ', ';\n    height: ', ';\n    transform: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  display: block;\n  margin: auto;\n  width: 25px;\n  height: 25px;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  border: 1px solid white;\n  border-radius: 50%;\n  transition: all 0.5s;\n\n  @media (min-width: 1200px) {\n    transform: ', ';\n  }\n'], ['\n  cursor: pointer;\n  display: block;\n  margin: auto;\n  width: 25px;\n  height: 25px;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  border: 1px solid white;\n  border-radius: 50%;\n  transition: all 0.5s;\n\n  @media (min-width: 1200px) {\n    transform: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 5px auto;\n  width: 1px;\n  height: 15px;\n  background-color: #979797;\n'], ['\n  margin: 5px auto;\n  width: 1px;\n  height: 15px;\n  background-color: #979797;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n'], ['\n  background-image: url(', ');\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _facebookIcon = __webpack_require__(1018);
	
	var _facebookIcon2 = _interopRequireDefault(_facebookIcon);
	
	var _instagramIcon = __webpack_require__(1019);
	
	var _instagramIcon2 = _interopRequireDefault(_instagramIcon);
	
	var _linkedinIcon = __webpack_require__(1020);
	
	var _linkedinIcon2 = _interopRequireDefault(_linkedinIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SocialLinks = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '20px' : '1%';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '50px' : 'auto';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '170px' : 'auto';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? 'rotate(-90deg)' : 'none';
	});
	
	var Icon = _styledComponents2.default.a(_templateObject2, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? 'rotate(90deg)' : 'none';
	});
	
	var Divider = _styledComponents2.default.span(_templateObject3);
	
	var InstagramLink = (0, _styledComponents2.default)(Icon)(_templateObject4, _instagramIcon2.default);
	
	var LinkedInLink = (0, _styledComponents2.default)(Icon)(_templateObject4, _linkedinIcon2.default);
	
	var FacebookLink = (0, _styledComponents2.default)(Icon)(_templateObject4, _facebookIcon2.default);
	
	exports.default = function (_ref) {
	  var path = _ref.path;
	  return _react2.default.createElement(
	    SocialLinks,
	    { path: path },
	    _react2.default.createElement(InstagramLink, {
	      href: 'https://www.instagram.com/goloobeff/',
	      target: '_blank',
	      path: path
	    }),
	    _react2.default.createElement(Divider, null),
	    _react2.default.createElement(FacebookLink, {
	      href: 'https://www.facebook.com/dmitry.golubev.712',
	      target: '_blank',
	      path: path
	    }),
	    _react2.default.createElement(Divider, null),
	    _react2.default.createElement(LinkedInLink, {
	      path: path
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/butler_regular-webfont.b53481cc.woff2";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @font-face {\n      font-family: "butlerregular";\n      src: url(', ') format("woff2");\n      font-weight: normal;\n      font-style: normal;\n  }\n\n  html { box-sizing: border-box; }\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n  }\n  html { min-height: 100%; }\n  body {\n    color: white;\n    font-family: \'Quattrocento Sans\', serif;\n    background: black;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n'], ['\n  @font-face {\n      font-family: "butlerregular";\n      src: url(', ') format("woff2");\n      font-weight: normal;\n      font-style: normal;\n  }\n\n  html { box-sizing: border-box; }\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n  }\n  html { min-height: 100%; }\n  body {\n    color: white;\n    font-family: \'Quattrocento Sans\', serif;\n    background: black;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  z-index: 1000;\n  position: fixed;\n  bottom: 0;\n  padding: 10px 0;\n  width: 50%;\n  color: white;\n  text-align: center;\n  font-size: 16px;\n  letter-spacing: 6px;\n  text-transform: uppercase;\n  background: black;\n  opacity: .8;\n\n  ', '\n'], ['\n  z-index: 1000;\n  position: fixed;\n  bottom: 0;\n  padding: 10px 0;\n  width: 50%;\n  color: white;\n  text-align: center;\n  font-size: 16px;\n  letter-spacing: 6px;\n  text-transform: uppercase;\n  background: black;\n  opacity: .8;\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: none;\n\n  @media (min-width: 1200px) {\n    cursor: pointer;\n    z-index: 1000;\n    position: fixed;\n    top: 35%;\n    left: 1%;\n    display: block;\n    font-family: \'Quattrocento Sans\';\n    text-align: center;\n    font-size: 16px;\n    letter-spacing: 6px;\n    text-transform: uppercase;\n    text-decoration: none;\n    transform-origin: 0 100%;\n    transition: all 0.5s;\n\n    top: ', ';\n    left: ', ';\n    padding: ', ';\n    width: ', ';\n    height: ', ';\n    transform: ', ';\n  }\n'], ['\n  display: none;\n\n  @media (min-width: 1200px) {\n    cursor: pointer;\n    z-index: 1000;\n    position: fixed;\n    top: 35%;\n    left: 1%;\n    display: block;\n    font-family: \'Quattrocento Sans\';\n    text-align: center;\n    font-size: 16px;\n    letter-spacing: 6px;\n    text-transform: uppercase;\n    text-decoration: none;\n    transform-origin: 0 100%;\n    transition: all 0.5s;\n\n    top: ', ';\n    left: ', ';\n    padding: ', ';\n    width: ', ';\n    height: ', ';\n    transform: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  color: #fff;\n  text-decoration: none;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n'], ['\n  color: #fff;\n  text-decoration: none;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  z-index: 1000;\n  position: fixed;\n  top: 33.7%;\n  left: 1%;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  color: #fff;\n  font-family: \'Quattrocento Sans\';\n  text-align: center;\n  font-size: 16px;\n  letter-spacing: 6px;\n  text-transform: uppercase;\n  text-decoration: none;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  cursor: pointer;\n  transition: all 0.5s;\n'], ['\n  z-index: 1000;\n  position: fixed;\n  top: 33.7%;\n  left: 1%;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  color: #fff;\n  font-family: \'Quattrocento Sans\';\n  text-align: center;\n  font-size: 16px;\n  letter-spacing: 6px;\n  text-transform: uppercase;\n  text-decoration: none;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  cursor: pointer;\n  transition: all 0.5s;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsive = __webpack_require__(60);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _social = __webpack_require__(696);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _media = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, __webpack_require__(809));
	
	var AppContainer = _styledComponents2.default.div(_templateObject2);
	
	var MobileLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3, (0, _media.desktop)(_templateObject4));
	
	var StyledLinkWrapper = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? 'calc(35% - 50px)' : '35%';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '50px' : '1%';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '40px 0 0 0' : '0';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '50px' : 'auto';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? '170px' : 'auto';
	}, function (props) {
	  return props.path === '/en/about/' || props.path === '/ru/about/' ? 'rotate(90deg)' : 'none';
	});
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject6);
	
	var Back = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject7);
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var link = location.pathname === '/en/about/' || location.pathname === '/ru/about/' ? '/' : '/en/about/';
	    var text = location.pathname === '/en/about/' || location.pathname === '/ru/about/' ? 'Back' : 'About';
	
	    var header = void 0;
	    if (location.pathname === '/') {
	      header = _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Gatsby Starter Blog'
	        )
	      );
	    } else {
	      header = _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Gatsby Starter Blog'
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      AppContainer,
	      null,
	      location.pathname === '/' ? _react2.default.createElement(
	        MobileLink,
	        { to: '/en/about/' },
	        'About'
	      ) : _react2.default.createElement(
	        MobileLink,
	        { to: '/' },
	        'Back'
	      ),
	      location.pathname === '/en/about/' || location.pathname === '/ru/about/' || location.pathname === '/' ? _react2.default.createElement(
	        StyledLinkWrapper,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { to: link },
	          text
	        )
	      ) : _react2.default.createElement(
	        StyledLinkWrapper,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { to: '/' },
	          "Back"
	        )
	      ),
	      location.pathname === '/en/about/' || location.pathname === '/ru/about/' || location.pathname === '/' ? _react2.default.createElement(_social2.default, null) : null,
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+Cjx0aXRsZT5mYWNlYm9vay1hcHAtc3ltYm9sPC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB1c2luZyBGaWdtYTwvZGVzYz4KPGcgaWQ9IkNhbnZhcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzg2OCA4ODMpIj4KPGcgaWQ9ImZhY2Vib29rLWFwcC1zeW1ib2wiPgo8ZyBpZD0iZl8xXyI+Cjx1c2UgeGxpbms6aHJlZj0iI3BhdGgwX2ZpbGwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zODY3LjU3IC04ODIuODU3KSIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjwvZz4KPC9nPgo8ZGVmcz4KPHBhdGggaWQ9InBhdGgwX2ZpbGwiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTSA1LjMwMjc5IDE1LjQwMzJMIDUuMzAyNzkgOC4zNzc1N0wgNy43MTAzMSA4LjM3NzU3TCA4LjA3MTUxIDUuNjM4NzZMIDUuMzAyNzkgNS42Mzg3NkwgNS4zMDI3OSAzLjg5MDQzQyA1LjMwMjc5IDMuMDk3NzMgNS41MjY2OSAyLjU1NzUxIDYuNjg4OTcgMi41NTc1MUwgOC4xNjg5NSAyLjU1NjkyTCA4LjE2ODk1IDAuMTA3MjI5QyA3LjkxMzAxIDAuMDc0NjYzMiA3LjAzNDQ1IDAgNi4wMTE5IDBDIDMuODc2NjUgMCAyLjQxNDgyIDEuMjc2MTIgMi40MTQ4MiAzLjYxOTE4TCAyLjQxNDgyIDUuNjM4NzZMIDAgNS42Mzg3NkwgMCA4LjM3NzU3TCAyLjQxNDgyIDguMzc3NTdMIDIuNDE0ODIgMTUuNDAzMkwgNS4zMDI3OSAxNS40MDMyWiIvPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KPHRpdGxlPmxpbmtlZGluLWxvZ288L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHVzaW5nIEZpZ21hPC9kZXNjPgo8ZyBpZD0iQ2FudmFzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzODY5IDgxOSkiPgo8ZyBpZD0ibGlua2VkaW4tbG9nbyI+CjxnIGlkPSJMaW5rZWRJbiI+Cjx1c2UgeGxpbms6aHJlZj0iI3BhdGgwX2ZpbGwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zODY5IC04MTguOTg0KSIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjwvZz4KPC9nPgo8ZGVmcz4KPHBhdGggaWQ9InBhdGgwX2ZpbGwiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTSAxMS45NzU0IDcuMDQ1NzhMIDExLjk3NTQgMTEuNDkyMUwgOS40MDg2OCAxMS40OTIxTCA5LjQwODY4IDcuMzQzNTdDIDkuNDA4NjggNi4zMDE0MyA5LjAzNzQzIDUuNTkwMjEgOC4xMDgzNiA1LjU5MDIxQyA3LjM5OTE0IDUuNTkwMjEgNi45NzcwOCA2LjA2OTUyIDYuNzkxNCA2LjUzMzE3QyA2LjcyMzY4IDYuNjk4OTIgNi43MDYyNSA2LjkyOTYzIDYuNzA2MjUgNy4xNjE2NUwgNi43MDYyNSAxMS40OTIxTCA0LjEzODY3IDExLjQ5MjFDIDQuMTM4NjcgMTEuNDkyMSA0LjE3MzI1IDQuNDY1ODYgNC4xMzg2NyAzLjczNzg5TCA2LjcwNiAzLjczNzg5TCA2LjcwNiA0LjgzNzAyQyA2LjcwMDggNC44NDUyNCA2LjY5NDAzIDQuODU0MSA2LjY4OTEzIDQuODYyMDdMIDYuNzA2IDQuODYyMDdMIDYuNzA2IDQuODM3MDJDIDcuMDQ3MSA0LjMwOTQyIDcuNjU2MjYgMy41NTU3MyA5LjAxOTc1IDMuNTU1NzNDIDEwLjcwOSAzLjU1NTcgMTEuOTc1NCA0LjY2Mzk5IDExLjk3NTQgNy4wNDU3OFpNIDEuNDUyODkgMEMgMC41NzQ1MjQgMCAwIDAuNTc4NiAwIDEuMzM5NDhDIDAgMi4wODM3OCAwLjU1NzkwMyAyLjY3OTk0IDEuNDE4ODEgMi42Nzk5NEwgMS40MzU5NiAyLjY3OTk0QyAyLjMzMTM0IDIuNjc5OTQgMi44ODgxOSAyLjA4Mzg5IDIuODg4MTkgMS4zMzk0OEMgMi44NzEzMSAwLjU3ODYgMi4zMzEzNCAwIDEuNDUyODkgMFpNIDAuMTUyNTg4IDExLjQ5MjFMIDIuNzE5MiAxMS40OTIxTCAyLjcxOTIgMy43Mzc5MkwgMC4xNTI1ODggMy43Mzc5MkwgMC4xNTI1ODggMTEuNDkyMVoiLz4KPC9kZWZzPgo8L3N2Zz4K"

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5f9fd7fc534ebc725d22.js